import React, { useCallback } from "react";
import { Card } from "@shopify/polaris";
import { missingAttributesOptions } from "../../../../../../../../../../constants/missingAttributesOptions.js";
import {
  ATTRIBUTE_QUALIFIER_IS_EMPTY,
  ATTRIBUTE_QUALIFIER_IS_FALSE
} from "../../../../../../../../../../constants/attributeQualifierTypes.js";
import {
  attributesWithBooleanQualifier,
} from "../../../../../../../../../../constants/attributeTypes.js";
import AttributeSelectField from "./AttributeSelectField.js";

const MissingAttributesCard = ({ input }) => {

  const handleSelectChange = useCallback((attribute) => {
    input.onChange({
      ...input.value,
      attribute,
      qualifier: attributesWithBooleanQualifier.includes(attribute) ? ATTRIBUTE_QUALIFIER_IS_FALSE : ATTRIBUTE_QUALIFIER_IS_EMPTY
    });
  }, [input.value, input.onChange]);

  return (
    <Card>
      <Card.Section>
        <div style={{ maxWidth: "50%" }}>
          <AttributeSelectField
            label={"Attributes"}
            options={missingAttributesOptions}
            onChange={handleSelectChange}
            value={input.value.attribute}
          />
        </div>
      </Card.Section>
    </Card>
  );
};

export default MissingAttributesCard;